import { useQuery } from '@apollo/client';

import { Deal } from '../gql/dealGql';
import { lienholderThirdPartyPayoffsQuery } from '../gql/prs/lienholderGql';
import { LienholderPRSType } from '../gql/prs/types';

import { getLienholderQueryVariables } from '../utils/prs';

type UseLienholderThirdPartyPayoffsProps = {
  deal: Deal;
  skip?: boolean;
};

// Whether PRS has the deal's lienholder paid off by a third party.
export const useLienholderThirdPartyPayoffs = ({
  deal,
  skip,
}: UseLienholderThirdPartyPayoffsProps): boolean => {
  const { state, slug } = getLienholderQueryVariables(deal);

  const { data } = useQuery<{
    lienholder: Pick<LienholderPRSType, 'third_party_payoffs'> | null;
  }>(lienholderThirdPartyPayoffsQuery, {
    skip: skip || !state || !slug,
    variables: { state, slug },
  });

  return data?.lienholder?.third_party_payoffs === true;
};
